import { render, staticRenderFns } from "./consume.vue?vue&type=template&id=2f05911a&scoped=true&"
import script from "./consume.vue?vue&type=script&lang=js&"
export * from "./consume.vue?vue&type=script&lang=js&"
import style0 from "./consume.vue?vue&type=style&index=0&id=2f05911a&prod&scoped=true&lang=less&"
import style1 from "./consume.vue?vue&type=style&index=1&id=2f05911a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f05911a",
  null
  
)

export default component.exports